import useTypedFlags from "./useTypedFlags";

const useOriginFlag = (): boolean => {
  const { vcsProviderOrigin } = useTypedFlags();

  return vcsProviderOrigin;
};

export default useOriginFlag;
